import { DHLError, handleHttpResponse, isSuccessfulResponse, getCurrentDate, axiosRequest } from '@general/js/utils';
import AbstractClass from './GenerateMemberCardsAbstractServices';
import { Services } from '../Services';

export default class GenerateMemberCardsServices extends AbstractClass {
  /**
   * Implicitly returns a Promise for fetching data of last ordered membership card (date and number of cards) and postal address
   *
   * @param {string} memberNumber - Member Number is used for get most recent order api for CRM from EAI0
   */
  static async getLastOrder(memberNumber) {
    try {
      const response = await axiosRequest().get(Services.MEMBERSHIP_CARD.GET_LAST_ORDER(memberNumber));
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getLastOrder() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Implicitly returns a Promise for fetching data of the Postal address
   *
   * @param {string} memberNumber - Member Number is used for get postal address api for CRM from EAI0
   */
  static async getPostalAddress(memberNumber, mostRecentAddress, currentDate = getCurrentDate()) {
    try {
      const response = await axiosRequest().get(Services.MEMBERSHIP_CARD.GET_POSTAL_ADDRESS(memberNumber, currentDate, mostRecentAddress));
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getPostalAddress() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Implicitly returns a Promise for submitting new card order to generate new membership card.
   *
   * @param {number} numberOfCards - Number of cards user ordered
   * @param {string} postalAddress - Either 'M' or 'P'
   * @param {string} currentDate - Current date
   */
  static async submitNewCardOrder(memberNumber, numberOfCards, postalAddress, currentDate) {
    try {
      const body = {
        numberOfCards,
        postalAddress,
        currentDate,
      };

      const response = await axiosRequest().post(Services.MEMBERSHIP_CARD.SUBMIT_NEW_CARD_ORDER(memberNumber), body);

      if (isSuccessfulResponse(response)) {
        return { orderSuccessFlag: true };
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response)}`);
    } catch (error) {
      throw new DHLError(`submitNewCardOrder() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getReferenceData() {
    try {
      const response = await axiosRequest().get(Services.MEMBERSHIP_CARD.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
